"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownNav = exports.CustomMenu = exports.CustomToggle = void 0;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
require("./DropdownNav.scss");
exports.CustomToggle = react_1.default.forwardRef((props, ref) => (react_1.default.createElement("a", { className: 'd-inline-flex justify-content-between align-items-center pb-4 pt-5 dropdownnav w-100', role: 'button', tabIndex: 0, "aria-controls": 'dropdownMenu', "aria-expanded": props.state ? 'true' : null, "aria-haspopup": "listbox", ref: ref, onClick: e => {
        e.preventDefault();
        props.onClick(e);
    } },
    props.children,
    react_1.default.createElement("span", { className: 'icon-right-arrow d-inline-block' }))));
exports.CustomMenu = react_1.default.forwardRef((props, ref) => {
    return (react_1.default.createElement("div", { ref: ref, style: props.style, className: props.className },
        react_1.default.createElement("ul", { className: 'd-block row g-0 no-list ps-0', id: 'dropdownMenu', role: 'listbox', "aria-labelledby": 'navLabel' }, react_1.default.Children.toArray(props.children))));
});
const DropdownNav = (props) => {
    var _a, _b;
    const [currentPage, setCurrentPage] = (0, react_1.useState)(props.currentTitle);
    const [dropdownState, setDropdownState] = (0, react_1.useState)(false);
    const links = (_a = props.pageProps) === null || _a === void 0 ? void 0 : _a.data.linkItems.value;
    const setpage = (e) => {
        setDropdownState(false);
        setCurrentPage(e);
        if (props.isSelect)
            props.setSelectState(e);
    };
    (0, react_1.useEffect)(() => {
        setCurrentPage(props.currentTitle);
        setDropdownState(false);
    }, [props.currentTitle]);
    return react_1.default.createElement(react_1.default.Fragment, null,
        !props.isSelect &&
            react_1.default.createElement("div", null,
                react_1.default.createElement("label", { className: 'visually-hidden', id: 'navLabel' }, (_b = props.pageProps.data.navigationLabel) === null || _b === void 0 ? void 0 : _b.value),
                react_1.default.createElement(react_bootstrap_1.Dropdown, { show: dropdownState, onSelect: (e) => setpage(e), onToggle: () => setDropdownState(!dropdownState) },
                    react_1.default.createElement(react_bootstrap_1.Dropdown.Toggle, { as: exports.CustomToggle, id: "dropdown-custom-components", state: dropdownState }, currentPage),
                    react_1.default.createElement(react_bootstrap_1.Dropdown.Menu, { as: exports.CustomMenu }, links.map(link => {
                        const active = currentPage === link.text ? 'active' : '';
                        return (react_1.default.createElement("li", { role: "option", key: `item-${link.href}` },
                            react_1.default.createElement("a", { key: link.text.replace(/[^a-z0-9]/gi, ''), href: link.href, className: `dropdown-item col-12 py-2 px-3 ${active}`, "aria-current": currentPage === link.text ? 'page' : null }, link.text)));
                    })))),
        props.isSelect &&
            react_1.default.createElement("div", null,
                react_1.default.createElement("label", { className: 'visually-hidden', id: 'navLabel' }, props.selectLabel),
                react_1.default.createElement(react_bootstrap_1.Dropdown, { show: dropdownState, onSelect: (e) => setpage(e), onToggle: () => setDropdownState(!dropdownState) },
                    react_1.default.createElement(react_bootstrap_1.Dropdown.Toggle, { as: exports.CustomToggle, id: "dropdown-custom-components", state: dropdownState }, currentPage),
                    react_1.default.createElement(react_bootstrap_1.Dropdown.Menu, { as: exports.CustomMenu }, props.selectOptions.map(link => {
                        const active = currentPage === link ? 'active' : '';
                        return (react_1.default.createElement("li", { role: "option", key: `item-${link}`, className: `dropdown-item select-item col-12 py-2 px-3 ${active}`, "aria-current": currentPage === link ? 'page' : null },
                            react_1.default.createElement("input", { className: 'd-none', type: "radio", id: link.replace(/[^a-z0-9]/gi, ''), onChange: () => setpage(link) }),
                            react_1.default.createElement("label", { htmlFor: link.replace(/[^a-z0-9]/gi, '') }, link)));
                    })))));
};
exports.DropdownNav = DropdownNav;
exports.default = exports.DropdownNav;
